/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { JofiSuccessDto } from '../models/jofi-success-dto';
import { JofiUpdateMatchDto } from '../models/jofi-update-match-dto';

@Injectable({
  providedIn: 'root',
})
export class JofiContentManagementMatchingService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation matchingControllerMarkMatchAsViewed
   */
  static readonly MatchingControllerMarkMatchAsViewedPath = '/v1/content-management/matching/viewed';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matchingControllerMarkMatchAsViewed()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matchingControllerMarkMatchAsViewed$Response(params: {
    context?: HttpContext
    body: JofiUpdateMatchDto
  }
): Observable<StrictHttpResponse<JofiSuccessDto>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentManagementMatchingService.MatchingControllerMarkMatchAsViewedPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiSuccessDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matchingControllerMarkMatchAsViewed$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matchingControllerMarkMatchAsViewed(params: {
    context?: HttpContext
    body: JofiUpdateMatchDto
  }
): Observable<JofiSuccessDto> {

    return this.matchingControllerMarkMatchAsViewed$Response(params).pipe(
      map((r: StrictHttpResponse<JofiSuccessDto>) => r.body as JofiSuccessDto)
    );
  }

  /**
   * Path part for operation matchingControllerMarkAsFavorite
   */
  static readonly MatchingControllerMarkAsFavoritePath = '/v1/content-management/matching/markAsFavorite';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matchingControllerMarkAsFavorite()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matchingControllerMarkAsFavorite$Response(params: {
    isFavorite: string;
    context?: HttpContext
    body: JofiUpdateMatchDto
  }
): Observable<StrictHttpResponse<JofiSuccessDto>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentManagementMatchingService.MatchingControllerMarkAsFavoritePath, 'patch');
    if (params) {
      rb.query('isFavorite', params.isFavorite, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JofiSuccessDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matchingControllerMarkAsFavorite$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matchingControllerMarkAsFavorite(params: {
    isFavorite: string;
    context?: HttpContext
    body: JofiUpdateMatchDto
  }
): Observable<JofiSuccessDto> {

    return this.matchingControllerMarkAsFavorite$Response(params).pipe(
      map((r: StrictHttpResponse<JofiSuccessDto>) => r.body as JofiSuccessDto)
    );
  }

}
